import { render, staticRenderFns } from "./MouldIndex.vue?vue&type=template&id=5d81a9ae&scoped=true&"
import script from "./MouldIndex.vue?vue&type=script&lang=js&"
export * from "./MouldIndex.vue?vue&type=script&lang=js&"
import style0 from "./MouldIndex.vue?vue&type=style&index=0&id=5d81a9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d81a9ae",
  null
  
)

export default component.exports